import {styled} from "@mui/material/styles"

export const KeyFilterContainer = styled("div")`
    padding: 0.5625rem 0;
    border-bottom: ${props => props.theme.colours.plp.facetDivider};
`
